<template>
  <d-container fluid class="main-content-container px-4">
    <!-- Page Header -->
    <page-header title="Lista" subTitle="Distribuidores">
      <router-link
        class="float-right text-white btn btn-success"
        :to="{ name: 'admin-distributor-new' }"
      >
        Novo Distribuidor
      </router-link>
    </page-header>

    <!-- Default Light Table -->
    <d-row>
      <d-col>
        <d-card class="card-small mb-4">
          <div
            class="card-header border-bottom d-flex justify-content-around custom-header"
          >
            <div class="col-md-3 col-12 d-flex align-items-center">
              <h6 class="m-md-0 m-2">Distribuidores</h6>
            </div>
            <div class="col-md-9 col-12 p-0">
              <form class="main w-100">
                <d-form-row>
                  <d-col
                    sm="12"
                    lg="3"
                    md="6"
                    class="d-flex mb-2 justify-content-start"
                  >
                    <d-select
                      v-model="pagination.status"
                      @change="onChangeSelect"
                    >
                      <option
                        :value="option.value"
                        v-for="(option, index) in statusOptions"
                        :key="index"
                      >
                        {{ option.text }}
                      </option>
                    </d-select>
                  </d-col>

                  <d-col
                    sm="12"
                    lg="3"
                    md="6"
                    class="d-flex mb-2 justify-content-start"
                  >
                    <select-state
                      :model.sync="pagination.state"
                      :onChange="onChangeSelect"
                    />
                  </d-col>
                  <d-col
                    lg="6"
                    md="12"
                    class="d-flex mb-2 justify-content-start"
                  >
                    <input-search
                      :model.sync="pagination.search"
                      id="input_distributor_list_search"
                    />
                  </d-col>
                </d-form-row>
              </form>
            </div>
          </div>
          <div class="card-body p-0 pb-3 text-left">
            <div class="table-overflow">
              <distributor-table :distributors="distributors.list" />
            </div>
            <pagination
              :total-items="distributors.total_items"
              :pagination.sync="pagination"
            />
          </div>
        </d-card>
      </d-col>
    </d-row>
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import PageHeader from '_shared/PageHeader.vue';
import Pagination from '_shared/Pagination.vue';
import SelectState from '_shared/SelectState.vue';
import InputSearch from '_shared/InputSearch.vue';
import paginationStorageMixin from '_common/mixins/paginationStorageMixin';
import DistributorTable from '../components/DistributorListTable.vue';
import { _UPDATE_DISTRIBUTOR_STATUS_ } from '../components/DistributorModel';

export default {
  name: 'distributor-team-list',
  components: {
    PageHeader,
    DistributorTable,
    SelectState,
    Pagination,
    InputSearch,
  },
  mixins: [paginationStorageMixin],
  data() {
    return {
      pagination: {
        search: '',
        state: null,
        status: null,
        skip: (this.$route.params.page - 1) * 10,
        take: 10,
        page: parseInt(this.$route.params.page, Number),
      },
      statusOptions: [
        { value: null, text: 'Selecione o status' },
        { value: 1, text: 'Ativo' },
        { value: 0, text: 'Inativo' },
      ],
    };
  },
  computed: {
    distributors() {
      const { distributorList } = this.$store.state.distributor;
      if (distributorList && distributorList.list.length) {
        return distributorList;
      }
      return {
        list: [],
        total_items: 0,
      };
    },
  },
  methods: {
    ...mapActions(['setToggle', 'checkAdmin', 'getDistributorList']),
    getList() {
      this.setToggle({ type: 'progress', bool: true });
      this.getDistributorList(this.pagination).then(() => {
        this.setToggle({ type: 'progress', bool: false });
      });
    },
    onChangeSelect() {
      this.pagination.skip = 0;
      this.pagination.page = 1;
    },
  },
  mounted() {
    this.checkAdmin();
    Events.$emit('sidebarVisible', false);
    Events.$on(_UPDATE_DISTRIBUTOR_STATUS_, () => {
      this.getList();
    });
    Events.$on('update:pagination', pagination => {
      const paramsPage = parseInt(this.$route.params.page, 10);
      this.saveCurrentPage(this.pagination);
      if (paramsPage !== pagination.page) {
        this.$router.push({ params: { page: pagination.page } });
      }
      this.getList();
    });
  },
  destroyed() {
    Events.$off('update:pagination');
    Events.$off(_UPDATE_DISTRIBUTOR_STATUS_);
  },
};
</script>
